import { render } from "./Volume.vue?vue&type=template&id=69fa9bdc&scoped=true"
import script from "./Volume.vue?vue&type=script&lang=ts"
export * from "./Volume.vue?vue&type=script&lang=ts"

import "./Volume.vue?vue&type=style&index=0&id=69fa9bdc&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-69fa9bdc"

export default script